import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Api, clearSession } from '../../api/Assinafy'
import { Alert, Form, Input, Icon } from '../../components'
import { Page } from '../../layout'
import { clearMfaChallenge, getMfaChallenge } from '../../utils/mfaChallenge'
import { navigateAfterLogin } from '../../utils/loginRedirect'

const MfaVerify = () => {
  const navigate = useNavigate()
  const [challenge] = useState(() => getMfaChallenge())
  const supportsTotp = challenge?.methods?.includes('Totp')

  useEffect(() => {
    if (!challenge) {
      navigate('/', {
        replace: true,
        state: {
          alert: {
            type: 'warning',
            message: 'Sua verificação expirou. Entre novamente para continuar.',
          },
        },
      })
    }
  }, [challenge, navigate])

  const restartLogin = () => {
    clearMfaChallenge()
    clearSession()
    navigate('/', { replace: true })
  }

  const handleSubmit = ({ code }) => {
    return Api('authentication/mfaVerify')({
      mfa_token: challenge.token,
      code: code.trim(),
    })
      .then(async ({ status }) => {
        if (status === 200) {
          const successPath = challenge.successPath
          clearMfaChallenge()
          if (successPath === '/dashboard') {
            await navigateAfterLogin(navigate)
          } else {
            navigate(successPath, { replace: true })
          }
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          clearMfaChallenge()
          clearSession()
          navigate('/', {
            replace: true,
            state: {
              alert: {
                type: 'warning',
                message: 'O desafio de verificação expirou ou foi encerrado. Entre novamente para gerar um novo.',
              },
            },
          })
          return
        }

        const attemptsRemaining = error?.response?.data?.data?.attempts_remaining
        if (error?.response?.data && !error.response.data.message) {
          error.response.data.message = 'Código inválido. Confira o código e tente novamente.'
        }
        if (attemptsRemaining != null) {
          error.response.data.message = `${error.response.data.message} Tentativas restantes: ${attemptsRemaining}.`
        }
        throw error
      })
  }

  if (!challenge) {
    return null
  }

  return (
    <Page
      className="page-sign"
      title="Verificação em duas etapas"
      opening="Digite o código do seu aplicativo autenticador ou use um código de recuperação."
    >
      {!supportsTotp && (
        <Alert variant="warning">
          Nenhum método de verificação compatível está disponível. Reinicie o login ou fale com o suporte.
        </Alert>
      )}

      <Form
        id="form-mfa-verify"
        className="form-sign"
        onSubmit={handleSubmit}
        size="lg"
        controls={[
          {
            Component: Input,
            name: 'code',
            label: 'Código de verificação ou recuperação',
            required: true,
            autoComplete: 'one-time-code',
            autoCapitalize: 'characters',
            autoFocus: true,
          },
        ]}
        buttons={[
          {
            variant: 'primary',
            submit: true,
            disabled: !supportsTotp,
            children: <>
              Verificar
              <Icon id="icon-arrow_forward" className="ms-2" size="24" />
            </>,
          },
          {
            variant: 'link',
            as: Link,
            to: '/',
            onClick: restartLogin,
            children: 'Voltar ao login',
          },
        ]}
      />
    </Page>
  )
}

export default MfaVerify
